import React from "react";
import Image from "next/image";

const MobBridgeProgram: React.FC = () => {
  return (
    <>
      <div className="bg-white">
        <div className="w-full px-5 py-8 text-white bg-[url(/home/footer_bg.png)]  shadow-xl">
          {/* Mobile View */}
          <div className="flex flex-col md:flex-row gap-8 md:gap-14 justify-center md:mt-6 md:mb-8">
            {/* Card 1 */}
            <div className="border border-[#1D5287]   bg-[#061A2F] px-6 py-4 rounded-xl md:w-[334px] md:h-[292px] w-full">
              <div className="leading-[1.2]">
                <div>
                  <Image
                    src="/cpa/bridge-course/university.svg"
                    alt="bridge course"
                    className="mx-auto py-4 md:py-8"
                    width={64}
                    height={64}
                    priority
                  />
                </div>
                <div className="mt-3 text-center text-[18px] md:text-[22px] leading-6 md:leading-7 font-medium">
                  Online M.Com Program
                  <br /> from Jain University
                </div>
                <div className="text-[18px] md:text-[22px] font-bold text-center mt-2">
                  NAAC A++ University
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="border border-[#1D5287]  bg-[#061A2F] px-6 py-4 rounded-xl md:w-[334px] md:h-[292px] w-full">
              <div className="leading-[1.2]">
                <Image
                  src="/cpa/bridge-course/integration.svg"
                  alt="bridge course"
                  className="mx-auto py-4 md:py-8"
                  width={64}
                  height={64}
                  priority
                />
                <div className="mt-3 text-center text-[18px] md:text-[22px] leading-6 md:leading-7 font-medium">
                  Fully integrated with the
                  <br /> Miles CPA exam coursework
                </div>
                <div className="text-[18px] md:text-[22px] font-bold text-center mt-2">
                  no extra studies beyond
                  <br /> CPA prep
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="border border-[#1D5287]  bg-[#061A2F] px-6 py-4 rounded-xl md:w-[334px] md:h-[292px] w-full">
              <div className="leading-[1.2]">
                <Image
                  src="/cpa/bridge-course/clock.svg"
                  alt="bridge course"
                  className="mx-auto py-4 md:py-8"
                  width={64}
                  height={64}
                  priority
                />
                <div className="mt-3 text-center text-[18px] md:text-[22px] leading-6 md:leading-7 font-medium">
                  Appear for the CPA exam
                  <br /> alongside the program
                </div>
                <div className="text-[18px] md:text-[22px] font-bold text-center mt-2">
                  no waiting till program
                  <br /> completion
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobBridgeProgram;
